export default __webpack_public_path__ + "f9aff846cf0cf9f72685c66cd3615e1e.svg";